
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon volume-slider",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","viewBox":"0 0 1979.996 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1928.208 491.62H52.494c-14.41 0-27.07-5.042-36.61-14.581-8.41-8.41-13.704-19.831-14.904-32.162-1.201-12.33 1.79-24.559 8.42-34.433 7.522-11.2 18.971-18.59 33.11-21.369L1918.225 20.356c15.243-3.002 30.866.946 42.864 10.815 11.997 9.868 18.878 24.437 18.878 39.971v368.72c0 28.54-23.219 51.758-51.759 51.758zM48.683 420.473c-16.743 3.292-16.144 18.324-15.854 21.303s2.602 17.844 19.665 17.844h1875.714c10.895 0 19.759-8.864 19.759-19.759V71.142c0-5.93-2.627-11.49-7.207-15.258a19.695 19.695 0 0 0-16.363-4.13L48.683 420.475z"}})])
          )
        }
      }
    